import Image from "next/image";
import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const LanguageSwitcher = () => {
  const [openLanguage, setOpenLanguage] = useState(false);

  const handleOpenLanguage = () => {
    setOpenLanguage(!openLanguage);
  };

  return (
    <div
      className={`relative w-full lg:w-fit p-2.5 cursor-pointer rounded-t-[20px] transition-all ${
        openLanguage && "bg-black"
      }`}
      onClick={handleOpenLanguage}
    >
      <button className="flex items-center w-full lg:w-fit gap-3">
        <Image
          alt="English flag"
          src="https://www.baghaffiliates.xyz/flags/bangladesh.png"
          width={46}
          height={30}
          className="object-cover w-10 h-6 lg:w-11.5 lg:h-7.5 rounded-full"
        />
        <p className="font-bold text-text1 text-xs lg:text-base">English</p>

        <FaChevronDown
          className={`text-text1 mx-1.5 text-xs mt-0.5 transition-all duration-300 ${
            openLanguage && "rotate-180"
          }`}
        />
      </button>
      {openLanguage && (
        <div className="absolute top-12 left-0 w-full bg-black rounded-b-[20px]">
          <button className="flex items-center py-2.5 px-2.5 gap-3">
            <Image
              alt="English flag"
              src="https://www.baghaffiliates.xyz/flags/bangladesh.png"
              width={46}
              height={30}
              className="object-cover w-10 h-6 lg:w-11.5 lg:h-7.5 rounded-full"
            />
            <p className="font-bold text-text1 text-xs lg:text-base">বাংলা</p>
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
